module.exports = __webpack_public_path__ + "src/assets/games/27/553.jpg";